$(document).on('keydown', 'form input, form select', function(e) {
  if (e.keyCode === 13 || e.key === 'Enter') {
    e.preventDefault();
    return false;
  }
});

$(document).on('keydown', 'form textarea', function(e) {
  if (e.isComposing || e.keyCode === 229) {
    return;
  }
  if ((e.keyCode === 13 || e.key === 'Enter') && !e.shiftKey) {
    e.preventDefault();
    const textarea = $(this);
    const start = textarea[0].selectionStart;
    const end = textarea[0].selectionEnd;
    const value = textarea.val();
    textarea.val(value.substring(0, start) + '\n' + value.substring(end));
    textarea[0].setSelectionRange(start + 1, start + 1);
    return false;
  }
});

$(document)
  .off('change.hospitalChooseFile', '.btn-choose-file')
  .on('change.hospitalChooseFile', '.btn-choose-file', function (e) {
    const $input = $(this);

    if ($input.data('processing')) {
      return false;
    }
    $input.data('processing', true);

    try {
      const files = this.files || [];

      if (files.length > 0) $('.error-images').addClass('d-none');

      updateHospitalFileName($input, files);

      const invalid = validateHospitalImages(files);
      if (invalid) {
        showHospitalImageModalError();
        this.value = '';
        const $scope = $input.closest('.form-hospital, .preview-wrapper, .form_item, .pl-31');
        $scope.find('.image-wrapper').not('.hospital-images').empty();
        return false;
      }

      let $targetWrapper = null;
      const $previewWrapper = $input.closest('.preview-wrapper');
      
      if ($previewWrapper.length > 0) {
        $targetWrapper = $previewWrapper.find('.image-wrapper').not('.hospital-images').first();
      } else {
        const $form = $input.closest('.form-hospital');
        if ($form.length > 0) {
          $targetWrapper = $form.find('.image-wrapper').not('.hospital-images').first();
        } else {
          const $scope = $input.closest('.form_item, .pl-31');
          if ($scope.length > 0) {
            $targetWrapper = $scope.find('.image-wrapper')
              .filter(function () {
                return $(this).closest('.preview-hospital').length === 0;
              })
              .first();
          }
        }
      }

      if ($targetWrapper && $targetWrapper.length === 1 && $targetWrapper.closest('.preview-hospital').length === 0) {
        imagesPreviewSafe(this, $targetWrapper);
      }
    } finally {
      $input.data('processing', false);
    }

    return false;
  });

function validateHospitalImages(files) {
  const maxSize = 10 * 1024 * 1024; // 10MB
  if (!files || files.length === 0) return false;

  if (files.length > 5) return true; // rule của bạn: max 5

  for (let i = 0; i < files.length; i++) {
    const f = files[i];
    if (!f.type || !f.type.startsWith('image/')) return true;
    if (f.size > maxSize) return true;
  }
  return false;
}

function showHospitalImageModalError() {
  if ($('#image_modal').length) return;

  $('body').append(`
    <div class="modal fade" id="image_modal" data-bs-backdrop="true" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="content-madal-text d-flex justify-content-center fw-bold px-3">
              画像ファイルのみ10MBサイズ以下でアップお願いします。
            </div>
          </div>
        </div>
      </div>
    </div>
  `);

  const modalEl = document.getElementById('image_modal');
  if (window.bootstrap && bootstrap.Modal) {
    const m = new bootstrap.Modal(modalEl);
    m.show();
    $(modalEl).on('hidden.bs.modal', function () { $('#image_modal').remove(); });
  } else {
    $('#image_modal').show().addClass('show');
    $(document).one('click', '#image_modal button', function () { $('#image_modal').remove(); });
  }
}

function updateHospitalFileName($input, files) {
  const fileName = document.getElementById("file-name");
  const maxChars = 20;
  if (!fileName) return;

  if (files && files.length > 0) {
    const selectedFile = files[0];
    let text = "";

    if (files.length > 5) {
      $('.file-error').removeClass('d-none');
      $input.val('');
      if ($('.cm_input_file_text').length) {
        $('.cm_input_file_text').text('※最大10MBまでアップできます。');
      }
      fileName.textContent = "※最大10MBまでアップできます。";
    } else if (files.length > 1) {
      fileName.textContent = `${files.length}つのファイル`;
      $('.file-error').addClass('d-none');
    } else {
      $('.file-error').addClass('d-none');
      text = selectedFile.name;
      text =
        text.length > maxChars
          ? text.substring(0, maxChars / 2) + "..." + text.substring(text.length - maxChars / 2)
          : text;
      fileName.textContent = text;
    }
  } else {
    const $scope = $input.closest('.form-hospital, .preview-wrapper, .form_item');
    const hasExistingImages = $scope.find('.image-wrapper img').length > 0;
    if (!hasExistingImages) fileName.textContent = "※最大10MBまでアップできます。";
  }
}

function imagesPreviewSafe(input, $place) {
  if (!input || !input.files || !$place || $place.length === 0) {
    return;
  }

  if ($place.length > 1) {
    $place = $place.first();
  }

  const token = Date.now() + Math.random();
  $(input).data('preview-token', token);

  if (input.files.length > 5) {
    return;
  }

  if ($(input).data('previewing')) {
    return;
  }
  $(input).data('previewing', true);

  $place.empty();
  
  const afterClear = $place.find('img, .js-preview-item, .pb-4, div').length;
  if (afterClear > 0) {
    $place.children().remove();
    $place.html('');
  }

  const files = Array.from(input.files);
  let loadedCount = 0;
  const processedFiles = new Set();
  const appendedFiles = new Set();

  files.forEach((file, index) => {
    const fileKey = file.name + '_' + file.size + '_' + file.lastModified;
    if (processedFiles.has(fileKey)) {
      return;
    }
    processedFiles.add(fileKey);

    const fileUniqueId = token + '_' + index;
    const reader = new FileReader();
    let onloadCalled = false;

    reader.onload = function (event) {
      if (onloadCalled) {
        return;
      }
      onloadCalled = true;

      const currentToken = $(input).data('preview-token');
      if (currentToken !== token) {
        return;
      }

      if ($place.length === 0) {
        return;
      }

      if (appendedFiles.has(fileUniqueId)) {
        return;
      }

      const existingImagesForThisFile = $place.find(`img[data-file-unique-id="${fileUniqueId}"]`).length;
      if (existingImagesForThisFile > 0) {
        return;
      }

      const imagesWithoutId = $place.find('img:not([data-file-unique-id])').length;
      if (imagesWithoutId > 0) {
        $place.find('img:not([data-file-unique-id])').closest('.js-preview-item, .pb-4').remove();
      }

      appendedFiles.add(fileUniqueId);

      const html = `
        <div class="pb-4 col-6 col-lg-4 col-xl-3 col-xxl-2 js-preview-item" data-file-unique-id="${fileUniqueId}" data-file-index="${index}">
          <img src="${event.target.result}" width="140" height="140" data-file-unique-id="${fileUniqueId}" data-file-index="${index}">
        </div>
      `;
      $place.append(html);

      loadedCount++;
      if (loadedCount === files.length) {
        $(input).data('previewing', false);
      }
    };

    reader.onerror = function() {
      loadedCount++;
      if (loadedCount === files.length) {
        $(input).data('previewing', false);
      }
    };

    reader.readAsDataURL(file);
  });
}

$(document).on("change", "#hospital_publication_date_year, #hospital_publication_date_month", function () {
  let year = $('#hospital_publication_date_year').val()
  let month = $('#hospital_publication_date_month').val()
  let day = $('#hospital_publication_date_day').val()
  const date = new Date(year, month - 1, 1);
  const days = [];

  while (date.getMonth() === month - 1) {
    days.push(date.getDate());
    date.setDate(date.getDate() + 1);
  }
  let options = '<option value="">—</option>'
  days.forEach(e => {
    options = options.concat(`"<option value="${e}" ${e == day ? 'selected' : ''}>${e}</option>"`)
  })
  if (year && month) {
    $('#hospital_publication_date_day').html(options)
  } else {
    $('#hospital_publication_date_day').html('<option value="">—</option>')
  }
})

$(document).on("click", ".btn-back-hospital", function () {
  $('.form-hospital').removeClass('d-none')
  $('.preview-hospital').addClass('d-none')
  $('.title-create').removeClass('d-none')
  $('.title-preview').addClass('d-none')
  $('.hospital-payment-preview-show').removeClass('d-none');
})

$(document).on("click", ".btn-preview-hospital", function () {
  let error = ""
  if (!$('.group_img').html().trim()) {
    $('.error-images').removeClass('d-none')
    error = error.concat('写真 、')
  } else {
    $('.error-images').addClass('d-none')
  }
  if (!$('#hospital_name').val()) {
    $('.error-name').removeClass('d-none')
    $('#hospital_name').addClass('input-invalid')
    error = error.concat('病院名 、')
  } else {
    $('.error-name').addClass('d-none')
    $('#hospital_name').removeClass('input-invalid')
    $('.hospital-name-preview').text($('#hospital_name').val())
  }
  if (!$('#hospital_director').val()) {
    $('.error-director').removeClass('d-none')
    $('#hospital_director').addClass('input-invalid')
    error = error.concat('院長 、')
  } else {
    $('.error-director').addClass('d-none')
    $('#hospital_director').removeClass('input-invalid')
    $('.hospital-director-preview').text($('#hospital_director').val())
  }
  if (!$('#pet-prefecture-select') || !$('#pet-city-select').val()) {
    $('.error-location').removeClass('d-none')
    $('#pet-prefecture-select').addClass('input-invalid')
    $('#pet-city-select').addClass('input-invalid')
    error = error.concat('住所 、')
  } else {
    $('.error-location').addClass('d-none')
    $('#pet-prefecture-select').removeClass('input-invalid')
    $('#pet-city-select').removeClass('input-invalid')
    $('.hospital-prefecture-preview').text($('#pet-prefecture-select').val())
    $('.hospital-city-preview').text($('#pet-city-select').val())
    $('.hospital-addition-location-preview').text($('#hospital_addition_location').val())
  }
  const phoneNumber = $('#hospital_phone_number').val();
  if (!phoneNumber) {
    $('.error-phone-number').removeClass('d-none')
    $('#hospital_phone_number').addClass('input-invalid')
    error = error.concat('電話番号 、')
  } else if (!/^\d{10,11}$/.test(phoneNumber)) {
    $('#phone_number_error').show()
    $('#hospital_phone_number').addClass('input-invalid')
    error = error.concat('電話番号 、')
  } else {
    $('.error-phone-number').addClass('d-none')
    $('#phone_number_error').hide()
    $('#hospital_phone_number').removeClass('input-invalid')
    $('.hospital-phone-number-preview').text(phoneNumber)
  }
  if (!(validateEmail($('#hospital_email').val()))) {
    $('.error-email-format').removeClass('d-none')
    $('#hospital_email').addClass('input-invalid')
    error = error.concat('メールアドレス 、')
  } else {
    $('.error-email-format').addClass('d-none')
    $('#hospital_email').removeClass('input-invalid')
    $('.hospital-email-preview').text($('#hospital_email').val())
  }
  if (!$('.medical_examinations').find('input[type="checkbox"]').is(':checked')) {
    $('.error-medical-examinations').removeClass('d-none')
    error = error.concat('診察について 、')
  } else {
    $('.error-medical-examinations').addClass('d-none')
    let text = ''
    $('.medical_examinations').find('input[type="checkbox"]').each(function () {
      if ($(this).is(':checked')) {
        $(this).siblings('label').text()
        text = text.concat($(this).siblings('label').text(), ' 、')
      }
    })
    if (text) text = text.slice(0, -1)
    $('.hospital-medical-examinations-preview').text(text)
  }
  let is_valid_work_schedule = false
  let invalid_input = []
  $('.work_schedule input').each(function (index) {
    if (index % 2 === 0) {
      if ($('.work_schedule input')[index].value && $('.work_schedule input')[index + 1].value && $('.work_schedule input')[index].value < $('.work_schedule input')[index + 1].value) {
        is_valid_work_schedule = true
      } else {
        invalid_input.push(index, index + 1)
      }
    }
  })
  if (!is_valid_work_schedule) {
    $('.error-work-schedule').removeClass('d-none')
    $('.work_schedule input').removeClass('input-invalid')
    invalid_input.forEach(function (index) {
      if (index % 2 === 0) {
        if (!(!$('.work_schedule input')[index].value && !$('.work_schedule input')[index + 1].value)) {
          $('.work_schedule input')[index].classList.add('input-invalid')
          $('.work_schedule input')[index + 1].classList.add('input-invalid')
        }
      }
    })
    error = error.concat('診察時間 、')
  } else {
    $('.error-work-schedule').addClass('d-none')
    $('.work_schedule input').removeClass('input-invalid')
    $('.work_schedule input').each(function (index) {
      if (index % 2 === 0) {
        let val_1 = $('.work_schedule input')[index].value ? $('.work_schedule input')[index].value : "—:—"
        let val_2 = $('.work_schedule input')[index + 1].value ? $('.work_schedule input')[index+1].value : "—:—"
        let text = val_1 + '~' + val_2
        $($('.work-schedule-preview')[index / 2]).text(text)
      }
    })
  }
  if (!$('.pets_category').find('input[type="checkbox"]').is(':checked')) {
    $('.error-pets-category').removeClass('d-none')
    error = error.concat('診察動物 、')
  } else {
    $('.error-pets-category').addClass('d-none')
    let text = ''
    $('.pets_category').find('input[type="checkbox"]').each(function () {
      if ($(this).is(':checked')) {
        $(this).siblings('label').text()
        text = text.concat($(this).siblings('label').text(), '、')
      }
    })
    if (text) text = text.slice(0, -1)
    $('.hospital-pets-category-preview').text(text)
  }
  if (!$('.services').find('input[type="checkbox"]').is(':checked')) {
    $('.error-services').removeClass('d-none')
    error = error.concat('診察動物 、')
  } else {
    $('.error-services').addClass('d-none')
    let text = ''
    $('.services').find('input[type="checkbox"]').each(function () {
      if ($(this).is(':checked')) {
        $(this).siblings('label').text()
        text = text.concat($(this).siblings('label').text(), ' 、')
      }
    })
    if (text) text = text.slice(0, -1)
    $('.hospital-services-preview').text(text)
  }
  if (!$('.non_working_days').find('input[type="checkbox"]').is(':checked')) {
    $('.error-non-working-days').removeClass('d-none')
    error = error.concat('診察動物 、')
  } else {
    $('.error-non-working-days').addClass('d-none')
    let text = ''
    $('.non_working_days').find('input[type="checkbox"]').each(function () {
      if ($(this).is(':checked')) {
        $(this).siblings('label').text()
        text = text.concat($(this).siblings('label').text())
      }
    })
    $('.hospital-non-working-days-preview').text(text)
  }
  if (!$('#hospital_notes').val()) {
    $('.error-notes').removeClass('d-none')
    $('#hospital_notes').addClass('input-invalid')
    error = error.concat('電話番号 、')
  } else {
    $('.error-notes').addClass('d-none')
    $('#hospital_notes').removeClass('input-invalid')
    $('.hospital-notes-preview').css('white-space', 'pre-wrap').css('word-wrap', 'break-word').text($('#hospital_notes').val())
  }
  if (!($('#hospital_publication_date_year').val() && $('#hospital_publication_date_month').val() && $('#hospital_publication_date_day').val())) {
    $('.error-publication-date').removeClass('d-none')
    $('#hospital_publication_date_year').addClass('input-invalid')
    $('#hospital_publication_date_month').addClass('input-invalid')
    $('#hospital_publication_date_day').addClass('input-invalid')
    error = error.concat('掲載希望日 、')
  } else {
    $('.error-publication-date').addClass('d-none')
    $('#hospital_notes').removeClass('input-invalid')
    $('#hospital_publication_date_year').removeClass('input-invalid')
    $('#hospital_publication_date_month').removeClass('input-invalid')
    $('#hospital_publication_date_day').removeClass('input-invalid')
    $('.hospital-publication-date').text($('#hospital_publication_date_year').val() + '年 ' + $('#hospital_publication_date_month').val() + '月 ' + $('#hospital_publication_date_day').val() + '日')
  }

  if ($('.payment')[0]) {
    let text = ''
    $('.payment').find('input[type="checkbox"]').each(function () {
      if ($(this).is(':checked')) {
        $(this).siblings('label').text()
        text = text.concat($(this).siblings('label').text(), '、')
      }
    })
    if (text) text = text.slice(0, -1)
    $('.hospital-payment-preview').text(text)
    if (text === "") {
      $('.hospital-payment-preview-show').addClass('d-none');
    }
  }

  if (error) {
    // Scroll to first error field
    const firstErrorField = $('.input-invalid').first()
    if (firstErrorField.length) {
      $('html, body').animate({
        scrollTop: firstErrorField.offset().top - 100
      }, 500)
      firstErrorField.focus()
    }
  } else {
    $('.hospital-error').addClass('d-none')
    $('.form-hospital').addClass('d-none')
    $('.preview-hospital').removeClass('d-none')
    $('.title-create').addClass('d-none')
    $('.title-preview').removeClass('d-none')
    $('html, body').animate({scrollTop: 0});
  }
})

const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^([a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/
    );
};

// Hide error messages when user starts typing
$(document).on('input', '#hospital_name', function() {
  $('.error-name').addClass('d-none')
  $(this).removeClass('input-invalid')
})

$(document).on('input', '#hospital_director', function() {
  $('.error-director').addClass('d-none')
  $(this).removeClass('input-invalid')
})

$(document).on('change', '#pet-prefecture-select, #pet-city-select', function() {
  $('.error-location').addClass('d-none')
  $('#pet-prefecture-select, #pet-city-select').removeClass('input-invalid')
})

$(document).on('input', '#hospital_phone_number', function() {
  const phoneNumber = $(this).val();
  const phoneError = $('#phone_number_error');
  const requiredError = $('.error-phone-number');
  
  requiredError.addClass('d-none');
  phoneError.hide();
  $(this).removeClass('input-invalid');
  
  if (phoneNumber && !/^\d{10,11}$/.test(phoneNumber)) {
    if (phoneNumber.length >= 10) {
      phoneError.show();
      $(this).addClass('input-invalid');
    }
  }
})

$(document).on('input', '#hospital_email', function() {
  $('.error-email-format').addClass('d-none')
  $(this).removeClass('input-invalid')
})

$(document).on('change', '.medical-examinations input[type="checkbox"]', function() {
  $('.error-medical-examinations').addClass('d-none')
})

$(document).on('input', '.work_schedule input', function() {
  $('.error-work-schedule').addClass('d-none')
})

$(document).on('change', '.pets-category input[type="checkbox"]', function() {
  $('.error-pets-category').addClass('d-none')
})

$(document).on('change', '.services input[type="checkbox"]', function() {
  $('.error-services').addClass('d-none')
})

$(document).on('change', '.non-working-days input[type="checkbox"]', function() {
  $('.error-non-working-days').addClass('d-none')
})

$(document).on('input', '#hospital_notes', function() {
  $('.error-notes').addClass('d-none')
  $(this).removeClass('input-invalid')
})

$(document).on('change', '#hospital_publication_date_year, #hospital_publication_date_month, #hospital_publication_date_day', function() {
  $('.error-publication-date').addClass('d-none')
})

// Hide image error when files are selected - đã được gộp vào handler chính
